import React, { useState, Fragment, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";
import SelectList from "./SelectList";
import InputText from "./InputText";


export default function InputSelect({ id, options = [], selected, onChange, onSelect, nullable, nullLabel, parseLabel, parseValue, ...rest }) {

    const [focused, setFocused] = useState(false);
    const [search, setSearch] = useState("");

    const input = useRef();
    const overlay = useRef();

    const searchTokens = search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(" ");
    const filteredOptions = options.filter(opt => {
        const optLabel = parseLabel(opt).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return searchTokens.every(search => optLabel.includes(search) )
    });

    function handleSelect(option, e) {
        onSelect && onSelect(option);
        onChange && onChange({ target: { id, value: parseValue(option) }})
        setFocused(false);
    }

    function handleFocus() {
        setFocused(true);
        setSearch("");
    }

    function handleBlur(e) {
        setFocused(false);
    }

    function handleKeyDown(e) {
        if(e.key === "Enter" && filteredOptions.length >= 1) {
            onSelect && onSelect(filteredOptions[0]);
            onChange && onChange({ id, target: { value: parseValue(filteredOptions[0]) }})
            setFocused(false);
        }
    }

    return (
        <Fragment>

            <InputText ref={input} className={"custom-select"}
                onClick={handleFocus} onFocus={handleFocus} onBlur={handleBlur}
                value={focused ? search : selected ? parseLabel(selected) : (nullLabel ? nullLabel : "")} 
                onValueChange={setSearch} onKeyDown={handleKeyDown}
                placeholder={(focused && selected) && parseLabel(selected)}
                {...rest}
            />

            <Overlay show={focused} target={input.current} placement="bottom-start" ref={overlay}>
                <Popover style={{maxHeight: 200, overflowY: 'auto', minWidth: (input.current ? input.current.clientWidth : 0) }}>
                    <Popover.Content className="px-0">
                        <SelectList variant="flush" nullLabel={nullLabel}
                            selected={selected} options={filteredOptions} nullable={nullable} 
                            parseLabel={parseLabel} parseValue={parseValue}
                            onSelect={handleSelect}
                        />
                    </Popover.Content>
                </Popover>
            </Overlay>

        </Fragment>
    )
}